import { render } from "./StaffLoginView.vue?vue&type=template&id=badef292&scoped=true"
import script from "./StaffLoginView.vue?vue&type=script&lang=js"
export * from "./StaffLoginView.vue?vue&type=script&lang=js"

import "./StaffLoginView.vue?vue&type=style&index=0&id=badef292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badef292"]])

export default __exports__